import React, { useState, useEffect } from "react";
import axios from "axios";
import { config as axiosConfig, SUB_POST_URL } from "../config/constants";

import Typography from "@material-ui/core/Typography";
import Navbar from "../components/Navbar";
import Page from "../components/common/Page";
import PostCard from "../components/common/PostCard";
import { CircularProgress } from "@material-ui/core";

const PostsFeed = () => {
  const [fetchingData, setFetchingData] = useState(false);
  const [data, setData] = useState(null);

  const config = axiosConfig(localStorage.getItem("jwt"));

  useEffect(() => {
    setFetchingData(true)
    axios.get(SUB_POST_URL, config).then((res) => {
      console.log(res.data.posts);
      setData(res.data.posts);
      setFetchingData(false)
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const likePost = (id) => {
    axios
      .put(`http://localhost:5000/like`, { postId: id }, config)
      .then((result) => {
        const newData = data.map((item) => {
          if (result.data._id === item._id) return result.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
  };

  const unlikePost = (id) => {
    axios
      .put(`http://localhost:5000/Unlike`, { postId: id }, config)
      .then((res) => {
        const newData = data.map((item) => {
          if (res.data._id === item._id) return res.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
  };

  const makeComment = (text, postId) => {
    // setComment("");
    axios
      .put(`http://localhost:5000/comment`, { text, postId }, config)
      .then((result) => {
        const newData = data.map((item) => {
          if (result.data._id === item._id) return result.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
  };

  const deletePost = (postId) => {
    axios
      .delete(`http://localhost:5000/deletepost/${postId}`, config)
      .then((res) => {
        const newData = data.filter((item) => {
          return item._id !== res.data;
        });
        setData(newData);
      });
  };

  return (
    <>
      <Navbar />
      {fetchingData && (
        <Page alignItems="center">
          <CircularProgress color="secondary" />
        </Page>
      )}
      {!fetchingData && Array.isArray(data) && data.length === 0 && (
        <Page alignItems="center">
          <Typography variant="caption" align="center">
            There is no post to show.
          </Typography>
        </Page>
      )}
      {!fetchingData && Array.isArray(data) && data.length > 0 && data.map((item) => (
        <div className="home" key={item._id}>
          <PostCard
            item={item}
            likePost={likePost}
            unlikePost={unlikePost}
            makeComment={makeComment}
            deltePost={deletePost}
          />
        </div>
      ))}
    </>
  );
};

export default PostsFeed;
